import React, { useState, useRef, useEffect } from "react";
import "./SQLiSimulator.css";

export default function SQLiSimulator() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [terminal, setTerminal] = useState("Ready.\n");
  const termRef = useRef(null);

  useEffect(() => {
    if (termRef.current) {
      termRef.current.scrollTop = termRef.current.scrollHeight;
    }
  }, [terminal]);

  const log = (msg) => setTerminal((t) => t + msg + "\n");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      log("[Error]: Cannot send empty username or password.");
      return;
    }
    log(`[Request]: Attempting login... username='${username}' password='${password}'`);
    try {
      const res = await fetch(
        "https://op5a5iw1c1.execute-api.ap-south-1.amazonaws.com/dev/sql-injection",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, password }),
        }
      );

      const text = await res.text();
      let output;
      try {
        const json = JSON.parse(text);
        output = json.body || text;
      } catch {
        output = text;
      }
      log(`[Response]: ${output}`);
    } catch (err) {
      log(`[Error]: ${err.message}`);
    }
  };

  const handleClear = () => {
    setUsername("");
    setPassword("");
    setTerminal("Ready.\n");
  };

  return (
    <div className="sqli-container">
      <h1 className="glitch sqli-title" data-text="SQL Injection Simulator">
      🩸 SQL Injection Simulator
      </h1>
      {/* <h2 className="sqli-subtitle">🩸 Hacker-style Lab</h2> */}

      <div className="sqli-window">
        {/* Input panel */}
        <div className="input-panel">
          <form onSubmit={handleSubmit} className="sqli-form">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="form-buttons">
              <button type="submit" className="primary-btn">
                Send
              </button>
              <button type="button" className="secondary-btn" onClick={handleClear}>
                Reset
              </button>
            </div>
          </form>
        </div>

        {/* Terminal panel */}
        <div className="terminal-panel">
          <h2>Terminal Output</h2>
          <pre ref={termRef} className="terminal">
            {terminal}
          </pre>
        </div>
      </div>

      <div className="footer-note">
        Educational simulator — never test real sites. Only safe for lab.
      </div>
    </div>
  );
}
